import { createSelector } from '@reduxjs/toolkit'
import { TENANT_CODES } from 'constant/conmon'
import { RootState } from 'libs'

/**
 *
 */
const authSelector = (state: RootState) => state.auth

export const loggedInUserSelector = createSelector(
  authSelector,
  authState => authState.loggedInUser,
)

export const auth = createSelector(authSelector, authState => authState.user)

export const isAdminLoginSelector = createSelector(
  authSelector,
  authState => authState.isAdmin,
)

export const tenantSelector = createSelector(
  authSelector,
  authState => authState.tenant?.tenant_code ?? TENANT_CODES.MILIZE,
)

export const tenantObjectSelector = createSelector(
  authSelector,
  authState => authState.tenant,
)

export const tenantDashboardSettingsSelector = createSelector(
  authSelector,
  authState => authState.tenant?.settings?.ui?.dashboard ?? null,
)

export const tenantCompanyDetailSettingsSelector = createSelector(
  authSelector,
  authState => authState.tenant?.settings?.ui?.company_detail ?? null,
)
